<script>
  import CabecalhoRelatorio from './CabecalhoRelatorio.vue';
  import Paginacao from '~componentes/Paginacao.vue';
  import transparenciaServico from '../../servico';
  import { datepicker } from 'vue-strap';

  export default {
    components: { CabecalhoRelatorio, Paginacao, datepicker },
    data() {
      return {
        projetos: [],
        orgaosFinaciadores: [],
        coordenadores: [],
        carregando: false,
        pagina: 1,
        totalRegistros: 0,
        totalPaginas: 0,
        registrosPorPagina: 0,
        idCoordenador: '',
        idOrgaoFinaciador: '',
        tituloProjeto: '',
        dataInicio: '',
        dataFim: '',
        objetivo: '',
        numeroConvenio: '',
        numeroProcesso: '',
        idMaisFiltros: '1',
        maisFiltros: [{ id: 1, text: 'Todos os projetos' }, { id: 2, text: 'Apenas projetos em execução' }, { id: 3, text: 'Apenas projetos finalizados' }],
        tipoOrgaos: [{ id: 1, text: 'Todos' }, { id: 2, text: 'Publico' }, { id: 3, text: 'Privado' }, { id: 4, text: 'Internacional' }],
        idTipoOrgao: '',
        filteredOrgaosFinanciadores: [],
      }
    },
    methods: {
      lista(pagina = 1) {
        this.carregando = true;
        return transparenciaServico
          .relatorioTransparencia(pagina, this.idCoordenador, this.idOrgaoFinaciador, this.tituloProjeto, this.dataInicio, this.dataFim,
            this.objetivo, this.numeroConvenio, this.numeroProcesso, this.idMaisFiltros, this.idTipoOrgao)
          .then(resultado => {
            this.projetos = resultado.registros;
            this.totalRegistros = resultado.totalRegistros;
            this.totalPaginas = resultado.totalPaginas;
            this.registrosPorPagina = resultado.registrosPorPagina;

            this.carregando = false;
          });
      },
      limparFiltros(callback) {
        this.$set(this, 'idCoordenador', '');
        this.$set(this, 'idOrgaoFinaciador', '');
        this.$set(this, 'tituloProjeto', '');

        this.$set(this, 'dataInicio', '');
        this.$set(this, 'dataFim', '');
        this.$set(this, 'numeroConvenio', '');
        this.$set(this, 'numeroProcesso', '');
        this.$set(this, 'objetivo', '');
        this.$set(this, 'idMaisFiltros', '1');
        this.$set(this, 'idTipoOrgao', '');

        this.$nextTick(() => {
          $('#coordenador').val('').trigger('change.select2')
          $('#orgao-financiador').val('').trigger('change.select2')
          $('#tipo-orgao').val('').trigger('change.select2')
          $('#mais-filtros').val('1').trigger('change.select2')
        });
        
        if (callback) return callback();
      },
      detalhar(id) {

        const filtrosAtivos = {};

        if (this.idCoordenador) filtrosAtivos.idCoordenador = this.idCoordenador;
        if (this.idOrgaoFinaciador) filtrosAtivos.idOrgaoFinaciador = this.idOrgaoFinaciador;
        if (this.tituloProjeto) filtrosAtivos.tituloProjeto = this.tituloProjeto;
        if (this.dataInicio) filtrosAtivos.dataInicio = this.dataInicio;
        if (this.dataFim) filtrosAtivos.dataFim = this.dataFim;
        if (this.numeroConvenio) filtrosAtivos.numeroConvenio = this.numeroConvenio;
        if (this.numeroProcesso) filtrosAtivos.numeroProcesso = this.numeroProcesso;
        if (this.objetivo) filtrosAtivos.objetivo = this.objetivo;
        if (this.idMaisFiltros) filtrosAtivos.idMaisFiltros = this.idMaisFiltros;
        if (this.idTipoOrgao) filtrosAtivos.idTipoOrgao = this.idTipoOrgao;

        this.$router.push({
          name: 'transparencia.projetos.detalhar',
          params: { id },
          query: filtrosAtivos
        });
      },
      iniciarSelect2TipoOrgaos() {
        const _this = this;

        $('#tipo-orgao').select2({
          theme: "bootstrap",
          placeholder: "Selecione...",
          language: "pt-BR",
          allowClear: true,
          minimumResultsForSearch: Infinity,
        }).change(function (e) {
          _this.$set(_this, 'idTipoOrgao', this.value);
        });

        $('#orgao-financiador').val('').trigger('change.select2')
      },
      iniciarSelect2MaisFiltros() {
        const _this = this;

        $('#mais-filtros').select2({
          theme: "bootstrap",
          language: "pt-BR",
          allowClear: false,
          minimumResultsForSearch: Infinity,
        }).change(function (e) {
          _this.$set(_this, 'idMaisFiltros', this.value);
        });
      },
      iniciarSelect2Coordenador() {
        const _this = this;

        $('#coordenador').select2({
          theme: "bootstrap",
          placeholder: "Selecione...",
          language: "pt-BR",
          allowClear: true,
        })
          .change(function(e) {
            _this.$set(_this, 'idCoordenador', this.value);
          });
      },
      iniciarSelect2OrgaoFinanciador() {
        const _this = this;

        $('#orgao-financiador').select2({
          theme: "bootstrap",
          placeholder: "Selecione...",
          language: "pt-BR",
          allowClear: true,
        })
          .change(function(e) {
            _this.$set(_this, 'idOrgaoFinaciador', this.value);
          });
      },
      listaDeCoordenadores() {
        return transparenciaServico
          .coordenadores()
          .then(coordenadores => {
            this.coordenadores = coordenadores;
          });
      },
      listaDeOrgaosFinaciadores() {
        return transparenciaServico
          .orgaosFinaciadores()
          .then(orgaosFinaciadores => {
            this.orgaosFinaciadores = orgaosFinaciadores;
          });
      },
      restoreFilters() {
        if (Object.keys(this.$route.query).length) {
          this.idCoordenador = this.$route.query.idCoordenador || '';
          this.idOrgaoFinaciador = this.$route.query.idOrgaoFinaciador || '';
          this.tituloProjeto = this.$route.query.tituloProjeto || '';
          this.dataInicio = this.$route.query.dataInicio || '';
          this.dataFim = this.$route.query.dataFim || '';
          this.numeroConvenio = this.$route.query.numeroConvenio || '';
          this.numeroProcesso = this.$route.query.numeroProcesso || '';
          this.objetivo = this.$route.query.objetivo || '';
          this.idMaisFiltros = this.$route.query.idMaisFiltros || '';
          this.idTipoOrgao = this.$route.query.idTipoOrgao || '';

          this.$nextTick(() => {
            $('#coordenador').val(this.idCoordenador).trigger('change.select2')
            $('#tipo-orgao').val(this.idTipoOrgao).trigger('change.select2')
            $('#mais-filtros').val(this.idMaisFiltros).trigger('change.select2')
          });
        }
      }
    },
    watch: {
      idTipoOrgao() {
        this.idOrgaoFinaciador = this.$route.query.idOrgaoFinaciador ? this.$route.query.idOrgaoFinaciador : '';
        if (this.idTipoOrgao === '1') {
          this.filteredOrgaosFinanciadores = this.orgaosFinaciadores
        } else {
          this.filteredOrgaosFinanciadores = this.orgaosFinaciadores.filter((orgao) => {
            return (orgao.tipo === parseInt(this.idTipoOrgao))
          });
        }
      },

      filteredOrgaosFinanciadores() {
        this.$nextTick(() => {
          $('#orgao-financiador').val(this.idOrgaoFinaciador).trigger('change.select2');
        });
      }
    },
    async mounted() {
      this.$root.tituloDaPagina = 'Portal da transparência';
      
      this.iniciarSelect2TipoOrgaos();
      this.iniciarSelect2MaisFiltros();
      
      await this.listaDeCoordenadores();
      this.iniciarSelect2Coordenador();
      
      await this.listaDeOrgaosFinaciadores();
      this.iniciarSelect2OrgaoFinanciador();
      this.restoreFilters();
      this.lista();
    },
  }
</script>

<template>
  <div>
    
    <div class="row">
      <div class="col-xs-12">

        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Filtrar projetos</h5>
          </div>

          <div class="ibox-content">

            <div class="hidden-print">
              <div class="row">
                <div class="col-xs-12">
                  <div class="form-group">
                    <label class="control-label" for="coordenador">Coordenador</label>

                    <select id="coordenador"
                            class="form-control"
                            v-model="idCoordenador">
                      <option :value="coordenador.id"
                              v-for="(coordenador, index) in coordenadores">
                        {{ coordenador.nome }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row">

                <div class="col-xs-6">
                  <div class="form-group">
                    <label class="control-label">Tipo do órgão</label>

                    <select id="tipo-orgao"
                            class="form-control"
                            v-model="idTipoOrgao">
                      <option :value="tipoOrgao.id"
                              v-for="(tipoOrgao, index) in tipoOrgaos">
                        {{ tipoOrgao.text }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-xs-6">
                  <div class="form-group">
                    <label class="control-label" for="orgao-financiador">Órgão de fomento</label>

                    <select id="orgao-financiador"
                            class="form-control"
                            v-model="idOrgaoFinaciador">
                      <option :value="orgaoFinanciador.id"
                              v-for="(orgaoFinanciador, index) in filteredOrgaosFinanciadores"
                              :key="orgaoFinanciador.id">
                        {{ orgaoFinanciador.nome }}
                      </option>
                    </select>
                  </div>
                </div>

              </div>

              <div class="row">

                <div class="col-xs-12">
                  <label class="control-label">Periodo de assinatura do projeto</label>
                </div>

                <div class="col-xs-3">
                  <div class="form-group">
                    <label class="control-label">De:</label>

                    <datepicker v-model="dataInicio"
                                format="dd/MM/yyyy"
                                placeholder="  /  /     "
                                lang="pt-BR"
                                data-vv-name="dataInicio"
                                data-vv-as="data inicial"
                                v-validate="'date_format:DD/MM/YYYY'">
                    </datepicker>
                  </div>
                </div>

                <div class="col-xs-3">
                  <div class="form-group">
                    <label class="control-label">Até</label>

                    <datepicker v-model="dataFim"
                                format="dd/MM/yyyy"
                                placeholder="  /  /     "
                                lang="pt-BR"
                                data-vv-name="dataFim"
                                data-vv-as="data fim"
                                v-validate="'date_format:DD/MM/YYYY'">
                    </datepicker>
                  </div>
                </div>

                <div class="col-xs-6">
                  <div class="form-group">
                    <label class="control-label">Mais filtros</label>

                    <select id="mais-filtros"
                            class="form-control"
                            v-model="idMaisFiltros">
                      <option :value="filtro.id"
                              v-for="(filtro, index) in maisFiltros">
                        {{ filtro.text }}
                      </option>
                    </select>
                  </div>
                </div>

              </div>
              
              <div class="row">
                 
                  <div class="col-xs-6">
                    <div class="form-group">
                      <label class="control-label">Objetivo</label>

                      <input type="text" class="form-control" id="objetivo" v-model="objetivo">
                    </div>
                  </div>

                  <div class="col-xs-3">
                    <div class="form-group">
                      <label class="control-label">Nº convênio/contrato</label>
                      <input type="text" class="form-control" id="numeroConvenio" v-model="numeroConvenio">
                    </div>
                  </div>

                  <div class="col-xs-3">
                    <div class="form-group">
                      <label class="control-label">Nº processo</label>
                      <input type="text" class="form-control" id="numeroProcesso" v-model="numeroProcesso">
                    </div>
                  </div>

                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <div class="form-group">
                      <label class="control-label">Título do projeto</label>

                      <input type="text" class="form-control" id="titulo-projeto" v-model="tituloProjeto">
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12">

                    <button class="btn btn-primary" type="button" @click="lista()">
                      <i class="fa fa-search"></i> Filtrar
                    </button>

                    <button class="btn btn-default" type="button" @click="limparFiltros(lista)">
                      <i class="fa"></i> Limpar filtros
                    </button>

                  </div>
                </div>
              </div>
            
            <div class="padding-5"></div>
            
            <cabecalho-relatorio titulo="Relatório de projetos" borda=""></cabecalho-relatorio>
        
            <div class="table-responsive">
              
              <table class="table table-bordered table-hover table-striped pointer relatorio">
                <thead>
                  <tr>
                    <th>Projeto</th>
                    <th>Órgão Financiador</th>
                    <th>Coordenador</th>
                    <th>Data início</th>
                    <th>Data término</th>
                    <th>Convênio/Contrato</th>
                    <th class="text-right">Valor&nbsp;(R$)</th>
                    <th class="action"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="projeto in projetos">
                    <td @click="detalhar(projeto.idProjeto)">{{ projeto.nomeProjeto }}</td>
                    <td @click="detalhar(projeto.idProjeto)">{{ projeto.nomeOrgaoFinanciador || '---' }}</td>
                    <td @click="detalhar(projeto.idProjeto)">{{ projeto.nomeCoordenador || '---' }}</td>
                    <td @click="detalhar(projeto.idProjeto)">{{ projeto.dataInicio | formatarData('---') }}</td>
                    <td @click="detalhar(projeto.idProjeto)">{{ projeto.dataTermino | formatarData('---') }}</td>
                    <td @click="detalhar(projeto.idProjeto)">{{ projeto.nrProcesso | '---' }}</td>
                    <td @click="detalhar(projeto.idProjeto)" class="text-right">{{ projeto.volumeTotalRecursos | formatarNumero }}</td>
                    <td>
                      <button class="btn btn-primary btn-xs" @click="detalhar(projeto.idProjeto)">
                        <i class="fa fa-file-text-o"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-show="carregando">
                    <td colspan="8">
                      <i class='fa fa-spinner fa-pulse'></i> Carregando...
                    </td>
                  </tr>
                </tbody>
              </table>
              
            </div>
        
            <paginacao
              :page-count="totalPaginas"
              :click-handler="lista"
              :per-page="registrosPorPagina"
              :register-count="totalRegistros"
              :show-counter="true">
            </paginacao>

          </div>
        </div>

      </div>
    </div>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/transparencia/componentes/compartilhado/ListaProjetos.vue